(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5603],{

/***/ 45603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/useOnEvent.js
var useOnEvent = __webpack_require__(80967);
// EXTERNAL MODULE: ./src/hooks/useURLState/index.ts + 1 modules
var useURLState = __webpack_require__(64105);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/hooks/useCart.main.tsx
var useCart_main = __webpack_require__(66508);
// EXTERNAL MODULE: ./src/components/AddressInstructionsModal/index.tsx + 1 modules
var AddressInstructionsModal = __webpack_require__(38708);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/helpers/websites/doesCountryRequireCookies.ts
var doesCountryRequireCookies = __webpack_require__(2840);
// EXTERNAL MODULE: ./src/hooks/useCountryCode.ts
var useCountryCode = __webpack_require__(50900);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/hooks/useWebsiteAddressInstructionModal.main.tsx
var useWebsiteAddressInstructionModal_main = __webpack_require__(40073);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/AdddressModals/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












function AddressModals() {
    var ref4;
    var preferences = (0,useCart_main/* default */.Z)();
    var useAddressModal = (0,useWebsiteAddressInstructionModal_main/* default */.Z)();
    var ref1 = _slicedToArray((0,useState/* useState */.e)(false), 2), openAddressInstructionsModal = ref1[0], setOpenAddressInstructionsModal = ref1[1];
    var ref2 = _slicedToArray((0,useState/* useState */.e)(false), 2), openOptions = ref2[0], setOpenOptions = ref2[1];
    var layout = (0,useLayout/* default */.Z)();
    var countryCode = (0,useCountryCode/* default */.Z)();
    var needCookies = (0,doesCountryRequireCookies/* default */.Z)(countryCode);
    var router = (0,next_router.useRouter)();
    var ref3 = _slicedToArray((0,useState/* useState */.e)(true), 2), shouldUse = ref3[0], setShouldUse = ref3[1];
    var isNotMobileLayoutAndUseCookies = needCookies && layout !== "mobile";
    (0,useEffect/* useEffect */.d)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.addressModal) {
            setShouldUse(false);
        }
    }, [
        (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.addressModal
    ]);
    (0,useEffect/* useEffect */.d)(function() {
        if (shouldUse && useAddressModal && !preferences.storeId && (isNotMobileLayoutAndUseCookies || !needCookies)) {
            setOpenAddressInstructionsModal(true);
        }
    }, [
        shouldUse,
        useAddressModal,
        preferences.storeId,
        needCookies
    ]);
    if (!shouldUse || !useAddressModal) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            openOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                isOpen: openOptions,
                onClose: function() {
                    return setOpenOptions(false);
                },
                actionLocation: "cart"
            }) : null,
            openAddressInstructionsModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInstructionsModal["default"], {
                isOpen: openAddressInstructionsModal,
                setOpen: setOpenAddressInstructionsModal,
                setOpenAddressModal: setOpenOptions
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/CartMenu/styles.module.css
var styles_module = __webpack_require__(67820);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/CartMenu/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}









var CartMenu = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CartMenu, _Component);
    var _super = _createSuper(CartMenu);
    function CartMenu() {
        _classCallCheck(this, CartMenu);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            className: "",
            showMessage: "close"
        };
        return _this;
    }
    var _proto = CartMenu.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var cart = this.props.cart;
        var prevCart = prevProps.cart;
        if (!prevCart) return; // First load, skip animation
        var total = cart && cart.totalPrice || 0;
        var prevTotal = prevCart && prevCart.totalPrice || 0;
        if (total > prevTotal) {
            this.attention();
        }
        if (!prevTotal && total) {
            this.showMessage();
        }
    };
    _proto.attention = function attention() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            className: "animated shake"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(1000);
                    case 3:
                        _this.setState({
                            className: "animated"
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.showMessage = function showMessage() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            showMessage: "show"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(3000);
                    case 3:
                        _this.setState({
                            showMessage: "hide"
                        });
                        _ctx.next = 6;
                        return (0,sleep/* default */.Z)(1000);
                    case 6:
                        _this.setState({
                            showMessage: "close"
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderLabelExtra = function renderLabelExtra() {
        if (this.props.deliveryType !== "serve") return;
        if (!this.props.tableName) return;
        return ", Mesa ".concat(this.props.tableName);
    };
    _proto.renderTotal = function renderTotal(param) {
        var cart = param.cart, total = param.total;
        if (cart) {
            return (0,formatNumber/* default */.Z)(total, "money");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    };
    _proto.renderCartIcon = function renderCartIcon() {
        if (this.props.tableName) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).cartIcon,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingBasket */.Kvb, {
                size: 20,
                "aria-label": "cart"
            })
        });
    };
    _proto.render = function render() {
        var _props = this.props, open = _props.open, onClick = _props.onClick, cart = _props.cart;
        var total = cart && cart.itemsPrice || 0;
        if (open) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).cartMenuClose,
                onClick: onClick,
                children: "Cerrar"
            });
        }
        var openClassName = total > 0 ? (styles_module_default()).cartHightlightMobile : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: openClassName + " " + (styles_module_default()).cartMenuOpen,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: this.props.t("order.cart.cartMenu.labelMyOrder", {
                        name: this.renderLabelExtra()
                    })
                }),
                this.props.tableName ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).icon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
                        size: 22
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).divider
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).cart,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).total + " " + this.state.className,
                            children: this.renderTotal({
                                cart: cart,
                                total: total
                            })
                        }),
                        this.renderCartIcon()
                    ]
                }),
                this.state.showMessage !== "close" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: this.state.showMessage === "show" ? (styles_module_default()).message : (styles_module_default()).messageHide,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).arrowWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).arrowUp
                            })
                        }),
                        this.props.t("order.titleOrderContinue")
                    ]
                }) : null
            ]
        });
    };
    return CartMenu;
}(react.Component);
/* harmony default export */ var Cart_CartMenu = ((0,esm/* withTranslation */.Zh)()(CartMenu));

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/index.tsx + 3 modules
var Content = __webpack_require__(81636);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/styles.module.css
var Cart_styles_module = __webpack_require__(16289);
var Cart_styles_module_default = /*#__PURE__*/__webpack_require__.n(Cart_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/index.tsx
function Cart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Cart_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Cart_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Cart_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Cart_slicedToArray(arr, i) {
    return Cart_arrayWithHoles(arr) || Cart_iterableToArrayLimit(arr, i) || Cart_unsupportedIterableToArray(arr, i) || Cart_nonIterableRest();
}
function Cart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Cart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cart_arrayLikeToArray(o, minLen);
}











function Cart() {
    var layout = (0,useLayout/* default */.Z)();
    var preferences = (0,useCart_main/* default */.Z)();
    var menuId = preferences.menuId, tableName = preferences.tableName, deliveryType = preferences.deliveryType, cart = preferences.cart;
    var ref = Cart_slicedToArray((0,useURLState/* default */.Z)("seeTableOrder"), 2), seeTableOrder = ref[0], setSeeTableOrder = ref[1];
    var isOpenQueryParam = seeTableOrder === "true";
    var ref1 = (0,react.useState)(isOpenQueryParam), open = ref1[0], setOpen = ref1[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order"
    }).t;
    (0,react.useEffect)(function() {
        if (!open && isOpenQueryParam) setSeeTableOrder("false");
    }, [
        open,
        isOpenQueryParam,
        setSeeTableOrder
    ]);
    (0,react.useEffect)(function() {
        if (isOpenQueryParam) setOpen(true);
    }, [
        isOpenQueryParam,
        seeTableOrder
    ]);
    (0,useOnEvent["default"])("setOpenCartMobile", function(value) {
        setOpen(value);
    });
    var renderCartContent = function() {
        if (!cart) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Cart_styles_module_default()).loadingContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Cart_styles_module_default()).loading
                })
            });
        }
        if (!menuId || !deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Cart_styles_module_default()).empty,
                children: t("cart.emptyCart")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default */.Z, {});
    };
    var renderCart = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Cart_styles_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Cart_styles_module_default()).title,
                            children: tableName ? t("tableDetails", {
                                table: tableName
                            }) : t("titleMyOrder")
                        }),
                        renderCartContent()
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressModals, {})
            ]
        });
    };
    if (layout === "mobile") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart_CartMenu, {
                    deliveryType: deliveryType,
                    tableName: tableName,
                    cart: cart,
                    open: open,
                    onClick: function() {
                        return setOpen(!open);
                    }
                }),
                open ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Cart_styles_module_default()).cartSmall,
                    children: [
                        renderCart(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Cart_styles_module_default()).iosBottomBar
                        })
                    ]
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Cart_styles_module_default()).cartBig,
        children: renderCart()
    });
};


/***/ }),

/***/ 67820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cartMenuClose":"_3yOlB89MyecJellQho2YhP cartMenuCloseMobile backgroundColor backgroundBorderColor","cartMenuOpen":"_32q0X75CsHOI__EBTyA3IG cartMenuOpenMobile backgroundColor backgroundBorderColor","total":"JBmgHlTxgErFu4MnS5GR-","icon":"KUikUSQU_SOHNbKNGJuMz","cart":"_3adoahL9bWDzCfY_GMKvBi","cartIcon":"_3srWo2v-BE3nr7SqLMOPlK","bellIcon":"_3MDnyQ2UqY3XI_ONQdYJPS","divider":"_1vzAzVndb1gPawXWjGasEQ","cartHightlightMobile":"KgGSn1stGwKTh12PwXjz8 primaryBackgroundColor","message":"GHq7KOp-U8x1rSeo0MSsJ animated fadeIn","messageHide":"BGZ_ZjaK5BMIOi3KG0kDB GHq7KOp-U8x1rSeo0MSsJ animated fadeIn fadeOut","arrowWrapper":"q0ooeBoPeuSX-ZwY0h1VZ","arrowUp":"khZz-T82IzKKaAdYCVn00"};

/***/ }),

/***/ 16289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2g4LAwTdUWHKKmx8yC0pln content","title":"_1jSkwIG9C9RJRoq8t9WjI- backgroundBorderColor","empty":"_3XHGjgIm3FRQVknefLMqTt","cartBig":"_2bC_nQoLsQ8Yl1wGta2nio","cartSmall":"_3q-OISHzklaF6gEQDrzuzJ cartContainerSmallMobile backgroundColor","iosBottomBar":"_2aqDQVal9dFyvcr5-Bk9pH","loadingContainer":"_33vIJ5FaqmpDN5Wa9O1j-6","loading":"_1aiHFRG8eApojD0fAN8nIM loadingGlow"};

/***/ })

}]);